import Status from "./status.tsx";

interface BackgroundProp {
    path: string;
}

const BackgroundMedia = ({path}: BackgroundProp) => {
    return (
        <div className="relative min-h-screen w-screen bg-black overflow-hidden">
                <img
                    src={path}
                    alt=""
                    className="absolute inset-0 w-full h-full object-contain object-center pointer-events-none select-none"
                />
            <Status />
        </div>
    );
}

export default BackgroundMedia;
